import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Info from '@mui/icons-material/Info';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';
import RefreshIcon from '@mui/icons-material/Refresh';

function PurchaseReturnIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );
    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };


    // const fetchtableData = async () => {
    //     fetchData('PurchaseReturnApi', `/${companyId}/${branchId}`, token)
    //         .then((response) => {
    //             if (response.responseCode === '1111') {
    //                 setData(response.response_data);
    //                 setFilteredData(response.response_data);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Purchase return Details:', error);
    //             // Handle error, e.g., redirect to login if token is expired
    //             if (error.response && error.response.status === 401) {
    //                 logout();
    //                 // Redirect to login with the current location as a parameter
    //                 history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
    //             }
    //         });
    // };

    const fetchtableData = async () => {

        setData([]);
        try {
            const response = await fetchData('PurchaseReturnApi', `/PurchasereturnDetails/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
                setFilteredData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }

    };

    const handleDelete = async () => {
        deleteData('PurchaseReturnApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('PurchaseReturnApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Purchase Return</h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '15px',
                        }}
                    />
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <Button
                    style={{ background: 'linear-gradient(to right, #041815ff, #045157ff)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '12px', textTransform: 'uppercase', marginTop: '20px', borderRadius: '25px' }}
                    onClick={fetchtableData}
                    className="linkcolor"
                >
                    Refresh
                </Button>

                {/* {hasCreateMasterPermission && (
                    <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
                        <Button
                            component={Link}
                            to="/PurchaseReturnCreate"
                            className="linkcolor"
                            style={{ background: 'linear-gradient(to right, #9a5a35ff, #6d3505ff)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '12px', textTransform: 'uppercase', marginTop: '-5px', borderRadius: '25px' }}
                        >
                            CREATE
                        </Button>
                    </div>
                )} */}

            </div>
            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>


            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#58A5B3' }}>
                            <TableRow>
                                <TableCell
                                    style={{
                                        backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey',
                                        borderRadius: '5px', color: 'white', width: '2%',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    SL NO
                                </TableCell>
                                <TableCell
                                    style={{
                                        backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey',
                                        borderRadius: '5px', color: 'white', width: '7%',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Bill DATE
                                </TableCell>
                                <TableCell
                                    style={{
                                        backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey',
                                        borderRadius: '5px', color: 'white', width: '7%',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Bill NUMBER
                                </TableCell>
                                <TableCell
                                    style={{
                                        backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey',
                                        borderRadius: '5px', color: 'white', width: '25%',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Supplier
                                </TableCell>

                                <TableCell
                                    style={{
                                        backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey',
                                        borderRadius: '5px', color: 'white', width: '10%',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    AMOUNT
                                </TableCell>
                                <TableCell
                                    style={{
                                        backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey',
                                        borderRadius: '5px', color: 'white', width: '10%',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    GST
                                </TableCell>
                                <TableCell
                                    style={{
                                        backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey',
                                        borderRadius: '5px', color: 'white', width: '15%',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    TOTAL
                                </TableCell>
                                <TableCell
                                    style={{
                                        backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey',
                                        borderRadius: '5px', color: 'white', width: '7%',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    TOTAL QUANTITY
                                </TableCell>
                                <TableCell
                                    style={{
                                        backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey',
                                        borderRadius: '5px', color: 'white', width: '10%',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>

                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredData.map((item, index) => (
                                <TableRow key={item.id} className={item.IsActive ? '' : 'inactiveRow'}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: '#e1f9f7ff', // Change color on hover
                                            cursor: 'pointer'
                                        },
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', padding: '3px', width: '2%', fontSize: '12px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', padding: '3px', width: '5%', fontSize: '12px' }}>{formatDate(item.BillDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', padding: '3px', width: '7%', fontSize: '12px' }}>{item.BillNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', padding: '3px', width: '25%', fontSize: '12px' }}>{item.SupplierName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', padding: '3px', width: '7%', textAlign: 'right', fontSize: '12px' }}>{item.Amount ? item.Amount.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', padding: '3px', width: '7%', textAlign: 'right', fontSize: '12px' }}>{item.GSTAmount ? item.GSTAmount.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', height: '20px', padding: '3px', width: '15%', textAlign: 'right', fontSize: '12px' }}>{item.TotalAmount ? item.TotalAmount.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', height: '20px', padding: '3px', width: '7%', textAlign: 'right', fontSize: '12px' }}>{item.TotalQuantity}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', height: '20px', padding: '3px', textAlign: 'right', width: '10%', fontSize: '12px' }}>

                                        <IconButton component={Link} to={`/PurchaseReturnDetails/${item.Id}`} color="warning">
                                            <Info style={{ fontSize: '19px' }} />
                                        </IconButton>

                                        {hasEditMasterPermission && item.IsActive && (
                                            <IconButton component={Link} to={`/PurchaseReturnEdit/${item.Id}`} color="primary">
                                                <EditIcon style={{ fontSize: '19px' }} />
                                            </IconButton>
                                        )}
                                        {hasDeleteMasterPermission && item.IsActive && (
                                            <IconButton onClick={() => openConfirmDialog(item.Id)} color="error">
                                                <DeleteIcon style={{ fontSize: '19px' }} />
                                            </IconButton>
                                        )}
                                        {!item.IsActive && (
                                            <IconButton onClick={() => handleActivate(item.Id)} color="success">
                                                <ActivateIcon style={{ fontSize: '19px' }} />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            {/* Confirmation Dialog */}

            <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <button
                        onClick={closeConfirmDialog}
                        style={{
                            backgroundColor: '#dc3545',
                            color: '#ffffff',
                            border: '1px solid #dc3545',
                            borderRadius: '4px',
                            padding: '8px 16px',
                            cursor: 'pointer',
                            marginRight: '8px',
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleDelete}
                        style={{
                            backgroundColor: '#28a745',
                            color: '#ffffff',
                            border: '1px solid #28a745',
                            borderRadius: '4px',
                            padding: '8px 16px',
                            cursor: 'pointer',
                        }}
                    >
                        Confirm
                    </button>
                </DialogActions>

            </Dialog>
        </div>
    );
}

export default PurchaseReturnIndex;

